import ComponentSwitch from '../..'

interface ProductFieldProps {
  fieldKey: string
  label: string
  value?: string
  showAsReadOnly: boolean
  inputId?: string | boolean
  placeholder?: string
  prefix?: string
  error?: string | boolean
  answer?: string
}

const ProductField = ({
  fieldKey,
  label,
  value,
  showAsReadOnly,
  inputId,
  placeholder,
  prefix = '',
  error,
  answer
}: ProductFieldProps) => {
  if (showAsReadOnly && value !== undefined) {
    return (
      <>
        <ComponentSwitch
          id={`${fieldKey}_label`}
          type="label"
          value={label}
          key={`${fieldKey}_label`}
        />
        <ComponentSwitch
          id={`${fieldKey}_value`}
          type="text"
          value={value}
          key={`${fieldKey}_value`}
        />
      </>
    )
  }

  return (
    <ComponentSwitch
      id={inputId || fieldKey}
      type="input"
      label={label}
      placeholder={placeholder || `Enter ${label.toLowerCase()} ...`}
      answer={answer}
      key={fieldKey}
      prefix={prefix}
      error={error}
    />
  )
}

export default ProductField
